import { MousePointer2 } from "lucide-react";
import { useViewport } from "@xyflow/react";
import type { ReactElement } from "react";
import {
  awarenessColor,
  remoteCanvasAwarenessPeers,
  useCanvasAwarenessPeers,
  type CanvasAwarenessHandle,
} from "./awareness.js";
import { PresenceTag } from "./PresenceTag.js";

export function PresenceCursors({
  awareness,
}: {
  awareness?: CanvasAwarenessHandle | null | undefined;
}): ReactElement | null {
  const peers = useCanvasAwarenessPeers(awareness);
  const remotePeers = remoteCanvasAwarenessPeers(awareness, peers);
  const { x, y, zoom } = useViewport();
  if (remotePeers.length === 0) return null;

  const cursorPeers = remotePeers.filter(
    (peer) => peer.state.cursor && peer.state.cursor !== null,
  );

  return (
    <>
      {cursorPeers.map((peer) => {
        const cursor = peer.state.cursor;
        if (!cursor) return null;
        const user = peer.state.user;
        const label = user?.name ?? "Collaborator";
        const color = awarenessColor(user?.color);
        return (
          <div
            key={peer.clientId}
            data-testid="presence-cursor"
            className="pointer-events-none absolute top-0 z-30"
            style={{
              // Cursor coordinates are physical canvas pixels, so anchor from the physical left edge.
              left: 0,
              transform: `translate(${x + cursor.x * zoom}px, ${y + cursor.y * zoom}px)`,
            }}
          >
            <MousePointer2
              aria-hidden
              className="h-5 w-5 drop-shadow-sm"
              style={{ color, fill: color }}
            />
            <PresenceTag
              name={label}
              color={color}
              className="ms-3 mt-0.5 max-w-36 truncate"
            />
          </div>
        );
      })}
    </>
  );
}
